export function waitForElement(queryFn, interval = 200, timeout = 5000) {
  return new Promise((resolve) => {
    let timesToCheck = timeout / interval;

    const check = () => {
      const result = queryFn();

      // eslint-disable-next-line no-prototype-builtins
      const isQueryAll = NodeList.prototype.isPrototypeOf(result);
      const isReady = isQueryAll ? result.length > 0 : !!result;

      if (isReady || timesToCheck <= 0) {
        resolve(result);
        return;
      }

      timesToCheck -= 1;

      setTimeout(check, interval);
    };

    check();
  });
}
